module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_list_arrow_gray-5947b835e77205c7f89d41c3bba81398.svg";